import i18n from "../i18n"
import { axios } from "@/helpers"
import router from "@/router"

export default {
    state: {
        siteData: {},
        siteLoadStatus: 0,
    },
    getters: {
        getSiteData(state) {
            return state.siteData
        },
        getSiteLoadStatus(state) {
            return state.siteLoadStatus
        },
    },
    mutations: {
        setSiteData(state, siteData) {
            state.siteData = siteData;
        },
        setSiteLoadStatus(state, status) {
            state.siteLoadStatus = status;
        },
    },
    actions: {
        loadSiteData({commit}) {
            commit('setSiteLoadStatus', 1);

            if(typeof router.currentRoute.name == "undefined") { //404
                commit('setSiteData', {});
                commit('setSiteLoadStatus', 4);

                return;
            }

            axios
                .get('/' + i18n.locale.split("_")[0] + '/site/' + router.currentRoute.params.slug)
                    .then(response => {
                        commit('setSiteData', response.data);
                        commit('setSiteLoadStatus', 2);
                    }).catch(() => {
                        commit('setSiteData', {});
                        commit('setSiteLoadStatus', 3);
                    });
        },
    }
}
